module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step3_Image1b.629f8c26.jpg";